import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../app/store';

export namespace AppStateScreen {
  export interface State {
    govId: string;
    govNo: string;
    mobile: string;
    regno: string;
    weight: string;
    registered: boolean;
    isActive: ActiveViewModel;
    address: string;
    zipCode: string;
    city: string;
    sessionActive: boolean;
    sourceLatitude: string;
    sourceLongitude: string;
    sourceAddress: string;
    destinationLatitude: string;
    destinationLongitude: string;
    destinationAddress: string;
    missionDate: string;
    missionTime: string;
    missionPrice: string;
    vehicleType: string;
    customerName: string;
    id: string;
    createCustomerGovNo: string;
    createCustomerEmail: string;
    createCustomerPhone: string;
    customerNumber: string;
  }

  export type ActiveViewModel = 'person' | 'company';
}

interface AppState {
  state: AppStateScreen.State;
}

const initialState: AppState = {
  state: {
    govId: '',
    govNo: '',
    mobile: '',
    regno: '',
    weight: '',
    registered: false,
    isActive: 'person',
    address: '',
    zipCode: '',
    city: '',
    sessionActive: false,
    sourceLatitude: '',
    sourceLongitude: '',
    sourceAddress: '',
    destinationLatitude: '',
    destinationLongitude: '',
    destinationAddress: '',
    missionDate: '',
    missionTime: '',
    missionPrice: '',
    vehicleType: '',
    customerName: '',
    id: '',
    createCustomerGovNo: '',
    createCustomerEmail: '',
    createCustomerPhone: '',
    customerNumber: '',
  },
};

export const appStateSlice = createSlice({
  name: 'appState',
  initialState,
  reducers: {
    setState: (state, action: PayloadAction<AppStateScreen.State>) => {
      // eslint-disable-next-line no-console
      state.state = action.payload;
    },
  },
});

export const { setState } = appStateSlice.actions;

export const selectAppState = (state: RootState) => state.appState.state;

export default appStateSlice.reducer;
